import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const IKEYBOARDING_ACTIVITY_INSTRUCTIONS_FRAGMENT = gql `
  fragment IKeyboardingActivityInstructionsFragment on IKeyboardingActivityInstructions {
    instructions {
      id
      audio {
        ...AssetFragment
      }
      text
    }
  }
  ${ASSET_FRAGMENT}
`;
export default IKEYBOARDING_ACTIVITY_INSTRUCTIONS_FRAGMENT;
